import type { HTMLAttributes } from 'react';
import { useSiteContext } from '@eti/providers';
import { getDurationAttributes } from './utils';

interface DurationProps extends Omit<HTMLAttributes<HTMLTimeElement>, 'dateTime'> {
  duration?: number | null;
}

const TimeDuration = ({ children, duration, ...props }: DurationProps) => {
  const { language } = useSiteContext();

  const { ariaLabel, dateTime } = getDurationAttributes(language.locale, duration ?? 0);

  return (
    <time aria-label={ariaLabel} dateTime={dateTime} {...props}>
      {children}
    </time>
  );
};

export default TimeDuration;
